// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P9-X","questions":"styles_questions__25LYm","footer":"styles_footer__q_h_q"};